import { List, IconTick, Text } from 'braid-design-system';

export const AccelerateFeatures = () => (
  <List type="icon" icon={<IconTick tone="formAccent" />}>
    {[
      'Feature at the top of search results',
      'Priority placement in daily buyer recommendation emails',
    ].map((feature, i) => (
      <Text key={i}>{feature}</Text>
    ))}
  </List>
);
